import type { LocalizedDict } from '../../../i18n'
const en = {
  previousBuild: 'Previous deployed build',
  previousDeployment: 'Previous deployment evidence',
  all: 'All',
  filters: 'Filter reports',
  status: 'Status',
  shell: 'Shell',
  kind: 'Kind',
  impact: 'Impact',
  from: 'Submitted from (UTC)',
  to: 'Submitted through (UTC)',
  dates: 'Enter valid UTC dates in order (0001-01-01 to 9999-12-30).',
  apply: 'Apply filters',
  empty: 'No reports match these filters.',
  route: 'Page',
  age: 'Submitted',
  admin: 'Admin',
  seller: 'Seller',
  supply: 'Supply',
  technical: 'Technical information',
  publicPreview: 'What the reporter sees',
  internal: 'Internal handling',
  assignee: 'Assigned reviewer',
  selectAssignee: 'Select an eligible reviewer',
  assign: 'Assign reviewer',
  currentAssignee: 'Current assignment',
  assigneeOutsidePage: 'Eligibility is not confirmed on this page.',
  noAssignees: 'No eligible reviewers on this page.',
  transition: 'New status',
  chooseTransition: 'Choose next status',
  publicNote: 'Explanation for the reporter',
  build: 'Deployed build',
  evidence: 'Deployment reference',
  environment: 'Reported environment',
  acknowledge: 'I confirm this build was deployed to the reported environment:',
  save: 'Save status',
  required:
    'Complete the explanation for the reporter and required deployment or closure information.',
  closure: 'Reason for closing without a fix',
  readonly:
    'You can review this report. Changes require current management permission and reporting enabled.',
  terminal: 'This report is closed. No further changes are available.',
  saved: 'Change saved.',
  conflict:
    'This report or assignment changed. Refresh the latest version, then review and send again. Your explanation for the reporter is preserved.',
  refresh: 'Refresh latest version',
  requests: 'Failed requests',
  copyId: 'Copy request ID',
  copied: 'Request ID copied',
  copyFailed: 'Could not copy. Select the displayed request ID.',
  noRequestId: 'No request ID was captured.',
  frontend: 'Frontend release',
  backend: 'Backend release',
  deployment: 'Deployment evidence',
  internalHistory: 'Internal history',
  assigned: 'Reviewer assigned',
  noNote: 'No public explanation',
  publicHelp:
    'Only submitted content, public outcomes and public history are visible to the reporter.',
  resume: 'An earlier change still needs its saved result checked.',
  openPending: 'Open pending report',
  next: 'Next reviewers',
  first: 'First reviewers',
}
export const adminCopy: LocalizedDict<typeof en> = {
  en,
  tr: {
    previousBuild: 'Önceki yayına alınan sürüm',
    previousDeployment: 'Önceki yayın kanıtı',
    all: 'Tümü',
    filters: 'Bildirimleri filtrele',
    status: 'Durum',
    shell: 'Panel',
    kind: 'Tür',
    impact: 'Etki',
    from: 'Gönderilme başlangıcı (UTC)',
    to: 'Gönderilme sonu (UTC)',
    dates: 'Geçerli UTC tarihlerini sıralı gir (0001-01-01 – 9999-12-30).',
    apply: 'Filtreleri uygula',
    empty: 'Bu filtrelere uyan bildirim yok.',
    route: 'Sayfa',
    age: 'Gönderilme',
    admin: 'Yönetim',
    seller: 'Satıcı',
    supply: 'Tedarik',
    technical: 'Teknik bilgiler',
    publicPreview: 'Bildirim sahibinin gördükleri',
    internal: 'İç işlem bilgileri',
    assignee: 'Atanan inceleyici',
    selectAssignee: 'Uygun inceleyici seç',
    assign: 'İnceleyici ata',
    currentAssignee: 'Mevcut atama',
    assigneeOutsidePage: 'Uygunluğu bu sayfada doğrulanmadı.',
    noAssignees: 'Bu sayfada uygun inceleyici yok.',
    transition: 'Yeni durum',
    chooseTransition: 'Sonraki durumu seç',
    publicNote: 'Bildiren kişiye gösterilecek açıklama',
    build: 'Yayına alınan sürüm',
    evidence: 'Yayın referansı',
    environment: 'Bildirimin ortamı',
    acknowledge: 'Bu sürümün bildirimin ortamına alındığını doğruluyorum:',
    save: 'Durumu kaydet',
    required: 'Açıklamayı ve gerekli yayın veya kapanış bilgilerini tamamla.',
    closure: 'Düzeltme olmadan kapatma nedeni',
    readonly:
      'Bu bildirimi inceleyebilirsin. Değişiklik için güncel yönetim yetkisi ve açık bildirim özelliği gerekir.',
    terminal: 'Bu bildirim kapandı. Yeni işlem yapılamaz.',
    saved: 'Değişiklik kaydedildi.',
    conflict:
      'Bildirim veya atama değişti. Son sürümü yenileyip kontrol ettikten sonra tekrar gönder. Açıklaman korundu.',
    refresh: 'Son sürümü yenile',
    requests: 'Başarısız istekler',
    copyId: 'İstek kimliğini kopyala',
    copied: 'İstek kimliği kopyalandı',
    copyFailed: 'Kopyalanamadı. Görünen istek kimliğini seç.',
    noRequestId: 'İstek kimliği yakalanmadı.',
    frontend: 'Ön yüz sürümü',
    backend: 'Arka uç sürümü',
    deployment: 'Yayın kanıtı',
    internalHistory: 'İç işlem geçmişi',
    assigned: 'İnceleyici atandı',
    noNote: 'Açıklama yok',
    publicHelp:
      'Bildirim sahibi yalnız gönderdiği içeriği, açık sonuçları ve açık geçmişi görür.',
    resume: 'Önceki değişikliğin kayıt sonucu hâlâ kontrol edilmeli.',
    openPending: 'Bekleyen bildirimi aç',
    next: 'Sonraki inceleyiciler',
    first: 'İlk inceleyiciler',
  },
}
